import { ServiceRequest } from '../../domain/requests/services/service.request';
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { ServicesRepository } from "../../repositories";
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AddServiceUsecase implements UseCase<ServiceRequest[], boolean> {

  constructor(private readonly serviceRepository: ServicesRepository) {
  }

  execute(params: ServiceRequest[]): Observable<boolean> {
    return this.serviceRepository.addService(params);
  }

}
